// extracted by mini-css-extract-plugin
module.exports = {"container":"_23yRa","title":"_2Wwek","content":"_2QM1J","links":"_3rFkM","button":"_39dZS"};